import request from '../axios'
import { baseUrl } from '@/config/env'

interface Params {
	[key: string]: any
}

// 多语言，根据分组id获取获取多语言下的所有数据
export const getLangDataApi = (params: Params) =>
	request({
		url: baseUrl + '/sys/sysLanguageGroup/treeNode',
		method: 'get',
		params: params,
		meta: {
			isToken: false
		}
	})

// 多语言，根据分组id获取获取多语言下的所有数据
export const getLangData = (params: Params) =>
	request({
		url: baseUrl + '/core/sys/bu/getById',
		method: 'get',
		params: params,
		meta: {
			isToken: false
		}
	})

// 查配了商品的门店
export const getPageStore = (params: Params) =>
	request({
		url: baseUrl + '/marking/api/mallProduct/pageStore',
		method: 'get',
		params: params,
		meta: {
			isToken: false
		}
	})

// 下单前校验
export const orderPreCheck = (params: Params) =>
	request({
		url: baseUrl + '/marking/api/mallProduct/orderPreCheck',
		method: 'post',
		data: params
	})

/** 根据配置编码查询系统全局配置。 */
export const getGlobalConfigByCodes = (params: Params) =>
	request({
		url: baseUrl + '/marking/api/mallProduct/getByCodes',
		method: 'get',
		params: params
	})
